/* @flow */
import { UAParser } from 'ua-parser-js'

const isSSR = typeof window === 'undefined' || import.meta.env.SSR

function getDeviceInfo() {
  // Web-only: no native app (Capacitor/Cordova removed). isCordova and isWebappMobile always false.
  if (isSSR) {
    return Object.freeze({
      isUndefined: true,
      isMobile: false,
      isIOS: false,
      isAndroid: false,
      isCordova: false,
      isDesktop: true,
      isWebappMobile: false,
      isMobileSize: false,
      isChrome: false,
      isSafari: false,
      hasSafeArea: false,
    })
  }
  const parser = new UAParser()
  const browser = parser.getBrowser()
  const device = parser.getDevice()
  const os = parser.getOS()
  const hasSafeArea = window.CSS && window.CSS.supports && window.CSS.supports('padding-top: env(safe-area-inset-top)')
  return Object.freeze({
    isUndefined: device.type === undefined,
    isMobile: device.type === 'mobile',
    isIOS: os.name === 'iOS',
    isAndroid: os.name === 'Android',
    isCordova: false,
    isDesktop: true,
    isWebappMobile: false,
    isMobileSize: window.innerWidth < 768,
    isChrome: ['Chromium', 'Chrome'].indexOf(browser.name) >= 0,
    isSafari: ['Mobile Safari', 'Safari', 'WebKit'].indexOf(browser.name) >= 0,
    hasSafeArea,
  })
}

export default getDeviceInfo()

export function isMobileViewport() {
  if (isSSR) return false
  const breakpoint = 768
  const viewportWidth = Math.min(document.documentElement.clientWidth, window.innerWidth)
  return viewportWidth <= breakpoint
}
